import { NgModule } from "@angular/core";
import { TruncatePipe } from "./pipe/truncate.pipe";

@NgModule({
    declarations: [ TruncatePipe ],
    exports: [ TruncatePipe ]
  })
  export class SharedModule { }